module.exports = __webpack_public_path__ + "img/schemeList07.f85256de.png";